<!-- add | edit object -->
<ng-container *ngIf="memberObjects.length">
  <h5 style="margin-bottom: 20px" *ngIf="isParent">Общие сведения (работник прокуратуры)</h5>
  <h5 style="margin-bottom: 20px" *ngIf="!isParent">Общие сведения (член семьи работника прокуратуры)</h5>
</ng-container>

<div class="form form-horizontal">

  <div class="form-body">

    <ng-container *ngIf="memberObjects.length">

      <!-- Vpo -->
      <ng-container *ngIf="isParent">
        <div class="form-group row">
           <label class="col-md-3 label-control">Округ <span class="danger">*</span></label>
           <div class="col-md-6">
                <mat-form-field class="example-full-width">
                  <input type="text" placeholder="..." aria-label="Number"
                         matInput [formControl]="vpoControl"
                         [matAutocomplete]="auto" required>
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of vpoObjects" [value]="option" (onSelectionChange)="selectVpo($event)">
                      {{option.shortName}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
        </div>
      </ng-container>

      <!-- Vp -->
      <ng-container *ngIf="isParent">
        <div class="form-group row">
          <label class="col-md-3 label-control">Прокуратура <span class="danger">*</span></label>
          <div class="col-md-6">
              <mat-form-field class="example-full-width">
                <input type="text" placeholder="..." aria-label="Number"
                       matInput [formControl]="vpControl"
                       [matAutocomplete]="auto2" required>
                <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
                  <mat-option *ngFor="let option of filteredVp$ | async" [value]="option" (onSelectionChange)="selectVp($event)">
                    {{option.name}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
          </div>
        </div>
      </ng-container>

      <!-- FIO -->
      <ng-container *ngIf="isParent">
        <div class="form-group row">
        <label class="col-md-3 label-control">ФИО <span class="danger">*</span></label>
        <div class="col-md-6">
          <mat-form-field class="example-full-width" [ngClass]="!isAdd ? 'readonly' : ''">
              <input type="text" placeholder="..." aria-label="Number"
                     matInput [formControl]="memberControl"
                     [readonly]="!isAdd"
                     [matAutocomplete]="auto3" required>
              <mat-autocomplete #auto3="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let option of filteredMembers$ | async" [value]="option" (onSelectionChange)="selectMember($event)">
                  {{option.lname + ' ' + option.fname + ' ' + option.sname}}
                </mat-option>
              </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      </ng-container>

      <!-- Parent FIO -->
      <ng-container *ngIf="!isParent">
        <div class="form-group row">
          <label class="col-md-3 label-control">Работник</label>
          <div class="col-md-6">
            <input type="text" class="form-control" [disabled]="true" [value]="parentMemberDocument.memberName">
          </div>
        </div>
      </ng-container>

      <!-- FIO -->
      <ng-container *ngIf="!isParent">
        <div class="form-group row">
          <label class="col-md-3 label-control">ФИО</label>
          <div class="col-md-6">
            <mat-form-field>
              <mat-select required [formControl]="memberControl">
                <mat-option *ngFor="let option of memberObjects" [value]="option" (onSelectionChange)="selectMember($event)">
                  {{option.lname + ' ' + option.fname + ' ' + option.sname + ' ' + option?.memberTypeName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </ng-container>

      <!-- Position -->
      <ng-container *ngIf="isParent">
        <div class="form-group row">
            <label class="col-md-3 label-control">Должность <span class="danger">*</span></label>
            <div class="col-md-6">
                <mat-form-field class="example-full-width">
                  <input type="text" placeholder="..." aria-label="Number"
                         matInput [formControl]="positionControl"
                         [matAutocomplete]="auto4" required>
                  <mat-autocomplete #auto4="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of filteredPositions$ | async" [value]="option" (onSelectionChange)="selectPosition($event)">
                      {{option.name}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
      </ng-container>

      <!-- Year -->
      <div class="form-group row">
        <label class="col-md-3 label-control">Год <span class="danger">*</span></label>
        <div class="col-md-6">
          <input class="form-control" [(ngModel)]="selected.year" type="text"
                 placeholder="Четыре цифры года"
                 [disabled]="!isAdd || !isParent ? true : false" required #itemYear="ngModel">
          <ng-container *ngIf="itemYear.invalid && (itemYear.dirty || itemYear.touched)">
            <small class="form-text text-muted danger"
                   *ngIf="itemYear.errors.required">это поле обязательно для заполнения</small>
          </ng-container>
          <app-user-hint [text]="'введите отчетный год, например: 2009'"></app-user-hint>
        </div>
      </div>

      <!-- Income -->
      <div class="form-group row">
        <label class="col-md-3 label-control">Общая сумма доходов <span class="danger">*</span></label>
        <div class="col-md-6">
          <input class="form-control" [(ngModel)]="selected.total"
                 type="text" placeholder="Доход, в руб."
                 pattern="[0-9\.]+"
                 required #itemTotal="ngModel">
          <ng-container *ngIf="itemTotal.invalid && (itemTotal.dirty || itemTotal.touched)">
            <small class="form-text text-muted danger"
                   *ngIf="itemTotal.errors.required">это поле обязательно для заполнения</small>
            <small class="form-text text-muted danger"
                   *ngIf="itemTotal.errors.pattern">вводить можно только цифры</small>
          </ng-container>
          <app-user-hint [text]="'введите общую сумму доходов (в рублях) за отчетный год, например: 30100.45'"></app-user-hint>
        </div>
      </div>

      <!-- Sort -->
      <ng-container *ngIf="isParent">
        <div class="form-group row">
          <label class="col-md-3 label-control">Сортировка</label>
          <div class="col-md-6">
            <input class="form-control" [(ngModel)]="selected.sort"
                   type="text" pattern="[0-9]+" #itemSort="ngModel">
            <ng-container *ngIf="itemSort.invalid && (itemSort.dirty || itemSort.touched)">
              <small class="form-text text-muted danger"
                     *ngIf="itemTotal.errors.required">это поле обязательно для заполнения</small>
              <small class="form-text text-muted danger"
                     *ngIf="itemTotal.errors.pattern">вводить можно только цифры</small>
            </ng-container>
            <app-user-hint [text]="'поставьте значение сортировки, цифра от 1 и выше (чем ниже цифра, тем выше человек в выводимом списке)'"></app-user-hint>
          </div>
        </div>
      </ng-container>

      <!-- Extra -->
      <div class="form-group row">
        <label class="col-md-3 label-control">Дополнительные сведения</label>
        <div class="col-md-6">
          <textarea class="form-control" [(ngModel)]="selected.extraData" placeholder="" rows="4" cols="6"></textarea>
          <app-user-hint [text]="'cведения об источниках получения средств, за счет которых совершена сделака (вид приобретенного имущества, источники)'"></app-user-hint>
        </div>
      </div>

      <!-- Show on the site sign -->
      <div class="form-group row">
          <label class="col-md-3 label-control">Показывать на сайте</label>
          <div class="col-md-6">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" [(ngModel)]="selected.isView">
              </div>
          </div>
      </div>

      <!-- Other stuff -->
      <ng-container *ngIf="!isAdd">

        <h5>Имущество</h5>

        <mat-tab-group>

          <mat-tab>
            <ng-template mat-tab-label>
              Недвижимое имущество
            </ng-template>
            <ng-template matTabContent>
              <div style="margin-top: 20px">
                <app-income-objects-block
                  [title]="'Недвижимое имущество'"
                  [hint]="'Добавить новые'"
                  [columns]="columnsL"
                  [data]="landObjects"
                  (removeItem)="removeData($event, 'land')"
                  (openDialog)="openLandAddDialog($event)">
                </app-income-objects-block>
              </div>
            </ng-template>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              Движимое имущество
            </ng-template>
            <ng-template matTabContent>
              <div style="margin-top: 20px">
                <app-income-objects-block
                  [title]="'Движимое имуществое'"
                  [hint]="'Добавить новые'"
                  [columns]="columnsC"
                  (removeItem)="removeData($event, 'car')"
                  (openDialog)="openCarAddDialog($event)"
                  [data]="carObjects">
                </app-income-objects-block>
              </div>
            </ng-template>
          </mat-tab>

        </mat-tab-group>

        <ng-container *ngIf="isParent">

          <h5 style="margin-top: 40px">Члены семьи</h5>
          <mat-tab-group>

            <mat-tab>

              <ng-template mat-tab-label>
                Общая информация
              </ng-template>
              <ng-template matTabContent>
                <div style="margin-top: 20px">
                  <app-income-objects-block
                    [title]="'Общая информация'"
                    [hint]="'Добавить нового'"
                    [columns]="columnsM"
                    [data]="familyMembers"
                    (removeItem)="removeMember($event)"
                    (openDialog)="openMemberAddDialog($event)">
                  </app-income-objects-block>
                </div>
              </ng-template>

            </mat-tab>

          </mat-tab-group>

        </ng-container>

      </ng-container>

      <!-- Information -->
      <ng-container *ngIf="isAdd">
        <div class="form-group row">
          <label class="col-md-3 label-control"></label>
          <div class="col-md-6">
            <p>
              <span class="badge badge-danger">Внимание!</span> Добавление дополнительной информации возможно <strong>только</strong>
              после сохранения основной!
            </p>
          </div>
        </div>
      </ng-container>

    </ng-container>

    <ng-container *ngIf="!memberObjects.length">
      <!-- Information -->
      <ng-container *ngIf="isAdd">
        <div class="form-group row">
          <label class="col-md-3 label-control"></label>
          <div class="col-md-9">
            <p>
              <span class="badge badge-danger">Внимание!</span> Добавьте нового члена семьи работника через справочник "Работники"
            </p>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="form-actions">
        <button class="btn btn-raised btn-warning mr-1" type="button" (click)="emitExit()">
          <i class="ft-x"></i> Закрыть
        </button>
        <button class="btn btn-raised btn-primary" type="button" type="button" (click)="save()" *ngIf="memberObjects.length">
          <i class="ft-check"></i> Сохранить
        </button>
    </div>

  </div>

</div>
